import * as React from "react";
const SvgAdUnits = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 1H5v22h14V1zm-2 18H7V5h10v14z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 6h8v2H8z",
  fill: "currentColor"
}));
export default SvgAdUnits;